import SaleBookTableRowView from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/components/SaleBookDetail/components/SaleBookTableRow/SaleBookTableRow'
import withSaleBookTableRow from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/components/SaleBookDetail/components/SaleBookTableRow/withSaleBookTableRow'

const SaleBookTableRow = withSaleBookTableRow(SaleBookTableRowView)

export default SaleBookTableRow
